module.exports = __webpack_public_path__ + "static/media/mcadam.e0f84e1c.png";